export default {
  mainShop: 'Main Shop',
  monitoredShops: 'Monitored Shops',
  favorites: 'Favorites',
  skuInFavorites: 'SKU in Favorites',
};
